"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// index.ts
var index_exports = {};
__export(index_exports, {
  Environment: () => Environment,
  IndexSource: () => IndexSource,
  Order: () => Order,
  Status: () => Status,
  createIndex: () => createIndex4,
  dropIndex: () => dropIndex4,
  listAvailableIndexes: () => listAvailableIndexes4,
  listIndexes: () => listIndexes4
});
module.exports = __toCommonJS(index_exports);

// src/data-v2-index-indexes.universal.ts
var import_transform_error = require("@wix/sdk-runtime/transform-error");
var import_rename_all_nested_keys = require("@wix/sdk-runtime/rename-all-nested-keys");

// src/data-v2-index-indexes.http.ts
var import_rest_modules = require("@wix/sdk-runtime/rest-modules");
var import_rest_modules2 = require("@wix/sdk-runtime/rest-modules");
function resolveComWixpressCloudDataApiIndexIndexServiceUrl(opts) {
  const domainToMappings = {
    "api._api_base_domain_": [
      {
        srcPath: "/cloud-data",
        destPath: ""
      }
    ],
    "code._base_domain_": [
      {
        srcPath: "/_api/cloud-data/v1/data-settings",
        destPath: "/v1/data-settings"
      },
      {
        srcPath: "/_api/cloud-data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/cloud-data/v1/connector",
        destPath: "/v1/connector"
      },
      {
        srcPath: "/_api/data/v1/data-settings",
        destPath: "/v1/data-settings"
      },
      {
        srcPath: "/_api/data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/data/v1/connector",
        destPath: "/v1/connector"
      },
      {
        srcPath: "/_api/cloud-data/v1/wix-data",
        destPath: "/v1/wix-data"
      }
    ],
    "cloud-data.wix-code.com": [
      {
        srcPath: "",
        destPath: ""
      }
    ],
    _: [
      {
        srcPath: "/_api/cloud-data",
        destPath: ""
      }
    ],
    "www._base_domain_": [
      {
        srcPath: "/_api/cloud-data",
        destPath: ""
      },
      {
        srcPath: "/_api/data",
        destPath: ""
      },
      {
        srcPath: "/_api/cloud-data",
        destPath: ""
      }
    ],
    "dev._base_domain_": [
      {
        srcPath: "/_api/cloud-data",
        destPath: ""
      }
    ],
    "bo._base_domain_": [
      {
        srcPath: "/_api/cloud-data/v1",
        destPath: "/v1"
      },
      {
        srcPath: "/_api/cloud-data/v2",
        destPath: "/v2"
      }
    ],
    "wixbo.ai": [
      {
        srcPath: "/_api/cloud-data/v1",
        destPath: "/v1"
      },
      {
        srcPath: "/_api/cloud-data/v2",
        destPath: "/v2"
      }
    ],
    "wix-bo.com": [
      {
        srcPath: "/_api/cloud-data/v1",
        destPath: "/v1"
      },
      {
        srcPath: "/_api/cloud-data/v2",
        destPath: "/v2"
      }
    ],
    "manage._base_domain_": [
      {
        srcPath: "/_api/cloud-data",
        destPath: ""
      },
      {
        srcPath: "/_api/data",
        destPath: ""
      },
      {
        srcPath: "/_api/cloud-data",
        destPath: ""
      }
    ],
    "editor._base_domain_": [
      {
        srcPath: "/_api/cloud-data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/cloud-data/dbs/tasks",
        destPath: "/dbs/tasks"
      },
      {
        srcPath: "/_api/data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/data/dbs/tasks",
        destPath: "/dbs/tasks"
      },
      {
        srcPath: "/_api/cloud-data/v1/wix-data",
        destPath: "/v1/wix-data"
      },
      {
        srcPath: "/_api/cloud-data/v1/data-settings",
        destPath: "/v1/data-settings"
      },
      {
        srcPath: "/_api/data/v2/indexes",
        destPath: "/v2/indexes"
      },
      {
        srcPath: "/_api/cloud-data/v1/external-database-connections",
        destPath: "/v1/external-database-connections"
      },
      {
        srcPath: "/_api/data/v1/data-collection-sharing",
        destPath: "/v1/data-collection-sharing"
      },
      {
        srcPath: "/_api/cloud-data/v2/collections",
        destPath: "/v2/collections"
      },
      {
        srcPath: "/_api/cloud-data/v2/bulk",
        destPath: "/v2/bulk"
      },
      {
        srcPath: "/_api/cloud-data/v2/items",
        destPath: "/v2/items"
      },
      {
        srcPath: "/_api/cloud-data/v2/dbs/tasks",
        destPath: "/v2/dbs/tasks"
      }
    ],
    "blocks._base_domain_": [
      {
        srcPath: "/_api/cloud-data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/cloud-data/dbs/tasks",
        destPath: "/dbs/tasks"
      },
      {
        srcPath: "/_api/data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/data/dbs/tasks",
        destPath: "/dbs/tasks"
      },
      {
        srcPath: "/_api/cloud-data/v1/wix-data",
        destPath: "/v1/wix-data"
      },
      {
        srcPath: "/_api/cloud-data/v1/data-settings",
        destPath: "/v1/data-settings"
      },
      {
        srcPath: "/_api/data/v2/indexes",
        destPath: "/v2/indexes"
      },
      {
        srcPath: "/_api/cloud-data/v1/external-database-connections",
        destPath: "/v1/external-database-connections"
      },
      {
        srcPath: "/_api/data/v1/data-collection-sharing",
        destPath: "/v1/data-collection-sharing"
      },
      {
        srcPath: "/_api/cloud-data/v2/collections",
        destPath: "/v2/collections"
      },
      {
        srcPath: "/_api/cloud-data/v2/bulk",
        destPath: "/v2/bulk"
      },
      {
        srcPath: "/_api/cloud-data/v2/items",
        destPath: "/v2/items"
      },
      {
        srcPath: "/_api/cloud-data/v2/dbs/tasks",
        destPath: "/v2/dbs/tasks"
      }
    ],
    "create.editorx": [
      {
        srcPath: "/_api/cloud-data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/cloud-data/dbs/tasks",
        destPath: "/dbs/tasks"
      },
      {
        srcPath: "/_api/data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/data/dbs/tasks",
        destPath: "/dbs/tasks"
      },
      {
        srcPath: "/_api/cloud-data/v1/wix-data",
        destPath: "/v1/wix-data"
      },
      {
        srcPath: "/_api/cloud-data/v1/data-settings",
        destPath: "/v1/data-settings"
      },
      {
        srcPath: "/_api/data/v2/indexes",
        destPath: "/v2/indexes"
      },
      {
        srcPath: "/_api/cloud-data/v1/external-database-connections",
        destPath: "/v1/external-database-connections"
      },
      {
        srcPath: "/_api/data/v1/data-collection-sharing",
        destPath: "/v1/data-collection-sharing"
      },
      {
        srcPath: "/_api/cloud-data/v2/collections",
        destPath: "/v2/collections"
      },
      {
        srcPath: "/_api/cloud-data/v2/bulk",
        destPath: "/v2/bulk"
      },
      {
        srcPath: "/_api/cloud-data/v2/items",
        destPath: "/v2/items"
      },
      {
        srcPath: "/_api/cloud-data/v2/dbs/tasks",
        destPath: "/v2/dbs/tasks"
      }
    ],
    "www.wixapis.com": [
      {
        srcPath: "/wix-data/v1/collections",
        destPath: "/v1/wix-data/collections"
      },
      {
        srcPath: "/wix-data/v1/external-database-connections",
        destPath: "/v1/external-database-connections"
      },
      {
        srcPath: "/wix-data/v2/indexes",
        destPath: "/v2/indexes"
      },
      {
        srcPath: "/wix-data/v1/items",
        destPath: "/v1/items"
      },
      {
        srcPath: "/wix-data/v1/bulk",
        destPath: "/v1/bulk"
      },
      {
        srcPath: "/wix-data/v1/external-databases",
        destPath: "/v1/external-databases"
      },
      {
        srcPath: "/wix-data/v2",
        destPath: "/v2"
      }
    ],
    "www.wixgateway.com": [
      {
        srcPath: "/wix-data/v1/items",
        destPath: "/v1/items"
      },
      {
        srcPath: "/wix-data/v1/bulk",
        destPath: "/v1/bulk"
      }
    ],
    "*.dev.wix-code.com": [
      {
        srcPath: "/_api/cloud-data/v2",
        destPath: "/v2"
      },
      {
        srcPath: "/_api/cloud-data/v1/external-database-connections",
        destPath: "/v1/external-database-connections"
      }
    ]
  };
  return (0, import_rest_modules2.resolveUrl)(Object.assign(opts, { domainToMappings }));
}
var PACKAGE_NAME = "@wix/auto_sdk_data_indexes";
function createIndex(payload) {
  function __createIndex({ host }) {
    const metadata = {
      entityFqdn: "wix.data.v2.index",
      method: "POST",
      methodFqn: "com.wixpress.cloud.data.api.index.IndexService.CreateIndex",
      packageName: PACKAGE_NAME,
      url: resolveComWixpressCloudDataApiIndexIndexServiceUrl({
        protoPath: "/v2/indexes",
        data: payload,
        host
      }),
      data: payload
    };
    return metadata;
  }
  return __createIndex;
}
function dropIndex(payload) {
  function __dropIndex({ host }) {
    const metadata = {
      entityFqdn: "wix.data.v2.index",
      method: "DELETE",
      methodFqn: "com.wixpress.cloud.data.api.index.IndexService.DropIndex",
      packageName: PACKAGE_NAME,
      url: resolveComWixpressCloudDataApiIndexIndexServiceUrl({
        protoPath: "/v2/indexes",
        data: payload,
        host
      }),
      params: (0, import_rest_modules.toURLSearchParams)(payload)
    };
    return metadata;
  }
  return __dropIndex;
}
function listIndexes(payload) {
  function __listIndexes({ host }) {
    const metadata = {
      entityFqdn: "wix.data.v2.index",
      method: "GET",
      methodFqn: "com.wixpress.cloud.data.api.index.IndexService.ListIndexes",
      packageName: PACKAGE_NAME,
      url: resolveComWixpressCloudDataApiIndexIndexServiceUrl({
        protoPath: "/v2/indexes",
        data: payload,
        host
      }),
      params: (0, import_rest_modules.toURLSearchParams)(payload)
    };
    return metadata;
  }
  return __listIndexes;
}
function listAvailableIndexes(payload) {
  function __listAvailableIndexes({ host }) {
    const metadata = {
      entityFqdn: "wix.data.v2.index",
      method: "GET",
      methodFqn: "com.wixpress.cloud.data.api.index.IndexService.ListAvailableIndexes",
      packageName: PACKAGE_NAME,
      url: resolveComWixpressCloudDataApiIndexIndexServiceUrl({
        protoPath: "/v2/indexes/available",
        data: payload,
        host
      }),
      params: (0, import_rest_modules.toURLSearchParams)(payload)
    };
    return metadata;
  }
  return __listAvailableIndexes;
}

// src/data-v2-index-indexes.universal.ts
var Order = /* @__PURE__ */ ((Order2) => {
  Order2["ASC"] = "ASC";
  Order2["DESC"] = "DESC";
  return Order2;
})(Order || {});
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["UNKNOWN"] = "UNKNOWN";
  Status2["BUILDING"] = "BUILDING";
  Status2["ACTIVE"] = "ACTIVE";
  Status2["DROPPING"] = "DROPPING";
  Status2["DROPPED"] = "DROPPED";
  Status2["FAILED"] = "FAILED";
  Status2["INVALID"] = "INVALID";
  return Status2;
})(Status || {});
var IndexSource = /* @__PURE__ */ ((IndexSource2) => {
  IndexSource2["UNKNOWN_INDEX_SOURCE"] = "UNKNOWN_INDEX_SOURCE";
  IndexSource2["SYSTEM"] = "SYSTEM";
  IndexSource2["USER"] = "USER";
  IndexSource2["AUTO"] = "AUTO";
  return IndexSource2;
})(IndexSource || {});
var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["UNKNOWN_ENVIRONMENT"] = "UNKNOWN_ENVIRONMENT";
  Environment2["SANDBOX"] = "SANDBOX";
  Environment2["SANDBOX_PREFERRED"] = "SANDBOX_PREFERRED";
  Environment2["LIVE"] = "LIVE";
  return Environment2;
})(Environment || {});
async function createIndex2(dataCollectionId, index) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = (0, import_rename_all_nested_keys.renameKeysFromSDKRequestToRESTRequest)({
    dataCollectionId,
    index
  });
  const reqOpts = createIndex(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return (0, import_rename_all_nested_keys.renameKeysFromRESTResponseToSDKResponse)(result.data)?.index;
  } catch (err) {
    const transformedError = (0, import_transform_error.transformError)(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { dataCollectionId: "$[0]", index: "$[1]" },
        singleArgumentUnchanged: false
      },
      ["dataCollectionId", "index"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function dropIndex2(dataCollectionId, indexName) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = (0, import_rename_all_nested_keys.renameKeysFromSDKRequestToRESTRequest)({
    dataCollectionId,
    indexName
  });
  const reqOpts = dropIndex(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
  } catch (err) {
    const transformedError = (0, import_transform_error.transformError)(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          dataCollectionId: "$[0]",
          indexName: "$[1]"
        },
        singleArgumentUnchanged: false
      },
      ["dataCollectionId", "indexName"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function listIndexes2(dataCollectionId, options) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = (0, import_rename_all_nested_keys.renameKeysFromSDKRequestToRESTRequest)({
    dataCollectionId,
    paging: options?.paging
  });
  const reqOpts = listIndexes(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return (0, import_rename_all_nested_keys.renameKeysFromRESTResponseToSDKResponse)(result.data);
  } catch (err) {
    const transformedError = (0, import_transform_error.transformError)(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          dataCollectionId: "$[0]",
          paging: "$[1].paging"
        },
        singleArgumentUnchanged: false
      },
      ["dataCollectionId", "options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function listAvailableIndexes2(dataCollectionId) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = (0, import_rename_all_nested_keys.renameKeysFromSDKRequestToRESTRequest)({
    dataCollectionId
  });
  const reqOpts = listAvailableIndexes(payload);
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return (0, import_rename_all_nested_keys.renameKeysFromRESTResponseToSDKResponse)(result.data);
  } catch (err) {
    const transformedError = (0, import_transform_error.transformError)(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { dataCollectionId: "$[0]" },
        singleArgumentUnchanged: false
      },
      ["dataCollectionId"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}

// src/data-v2-index-indexes.public.ts
function createIndex3(httpClient) {
  return (dataCollectionId, index) => createIndex2(
    dataCollectionId,
    index,
    // @ts-ignore
    { httpClient }
  );
}
function dropIndex3(httpClient) {
  return (dataCollectionId, indexName) => dropIndex2(
    dataCollectionId,
    indexName,
    // @ts-ignore
    { httpClient }
  );
}
function listIndexes3(httpClient) {
  return (dataCollectionId, options) => listIndexes2(
    dataCollectionId,
    options,
    // @ts-ignore
    { httpClient }
  );
}
function listAvailableIndexes3(httpClient) {
  return (dataCollectionId) => listAvailableIndexes2(
    dataCollectionId,
    // @ts-ignore
    { httpClient }
  );
}

// src/data-v2-index-indexes.context.ts
var import_rest_modules3 = require("@wix/sdk-runtime/rest-modules");
var createIndex4 = /* @__PURE__ */ (0, import_rest_modules3.createRESTModule)(createIndex3);
var dropIndex4 = /* @__PURE__ */ (0, import_rest_modules3.createRESTModule)(dropIndex3);
var listIndexes4 = /* @__PURE__ */ (0, import_rest_modules3.createRESTModule)(listIndexes3);
var listAvailableIndexes4 = /* @__PURE__ */ (0, import_rest_modules3.createRESTModule)(listAvailableIndexes3);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Environment,
  IndexSource,
  Order,
  Status,
  createIndex,
  dropIndex,
  listAvailableIndexes,
  listIndexes
});
//# sourceMappingURL=index.js.map